(function () {
  function init(root) {
    if (!root || root.dataset.luxHomeReady === 'true') return;
    root.dataset.luxHomeReady = 'true';

    var transformTrack = root.querySelector('[data-lux-transform-track]');
    var transformPrev = root.querySelector('[data-lux-transform-prev]');
    var transformNext = root.querySelector('[data-lux-transform-next]');

    function moveTransform(direction) {
      if (!transformTrack) return;
      transformTrack.scrollBy({
        left: transformTrack.clientWidth * direction,
        behavior: 'smooth'
      });
    }

    if (transformPrev) {
      transformPrev.addEventListener('click', function () {
        moveTransform(-1);
      });
    }

    if (transformNext) {
      transformNext.addEventListener('click', function () {
        moveTransform(1);
      });
    }

    function initMarquee(track, speed) {
      if (!track || track.dataset.luxMarqueeReady === 'true') return;

      var originals = Array.prototype.slice.call(track.children);
      if (originals.length < 2) return;

      track.dataset.luxMarqueeReady = 'true';
      track.classList.add('is-lux-marquee');

      var clones = originals.map(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('img').forEach(function (image) {
          image.alt = '';
        });
        track.appendChild(clone);
        return clone;
      });

      var paused = false;
      var resumeTimer;
      var lastTime = performance.now();
      var position = track.scrollLeft || 0;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function setPaused(value) {
        paused = value;
        if (resumeTimer) window.clearTimeout(resumeTimer);
      }

      function resumeSoon() {
        if (resumeTimer) window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(function () {
          paused = false;
        }, 1400);
      }

      track.addEventListener('mouseenter', function () { setPaused(true); });
      track.addEventListener('mouseleave', function () { setPaused(false); });
      track.addEventListener('focusin', function () { setPaused(true); });
      track.addEventListener('focusout', function () { setPaused(false); });
      track.addEventListener('touchstart', function () { setPaused(true); }, { passive: true });
      track.addEventListener('touchend', resumeSoon, { passive: true });
      track.addEventListener('pointerdown', function () { setPaused(true); });
      track.addEventListener('pointerup', resumeSoon);

      function animate(now) {
        if (!track.isConnected) return;

        var elapsed = Math.min(now - lastTime, 60);
        lastTime = now;

        if (!paused && !reduceMotion.matches && document.visibilityState === 'visible') {
          var loopWidth = clones[0].offsetLeft - originals[0].offsetLeft;

          // Keep a floating-point position. Some browsers round scrollLeft to a
          // whole pixel, so sub-pixel movement can otherwise appear stationary.
          position += speed * elapsed / 1000;

          if (loopWidth > 0 && position >= loopWidth) {
            position -= loopWidth;
          }

          track.scrollLeft = position;
        } else {
          position = track.scrollLeft || 0;
        }

        window.requestAnimationFrame(animate);
      }

      window.requestAnimationFrame(animate);
    }

    // Gentle movement for transformations and organisational logos.
    initMarquee(transformTrack, 18);
    initMarquee(root.querySelector('.lux-home-v2__logo-track'), 26);

    var reviewTrack = root.querySelector('.lux-home-v2__review-grid');
    var reviewPrev = root.querySelector('[data-lux-review-prev]');
    var reviewNext = root.querySelector('[data-lux-review-next]');

    function moveReview(direction) {
      if (!reviewTrack) return;

      var card = reviewTrack.querySelector('.lux-home-v2__review-card');
      var distance = card
        ? card.getBoundingClientRect().width + 22
        : reviewTrack.clientWidth * 0.85;

      reviewTrack.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    }

    if (reviewPrev) {
      reviewPrev.addEventListener('click', function () {
        moveReview(-1);
      });
    }

    if (reviewNext) {
      reviewNext.addEventListener('click', function () {
        moveReview(1);
      });
    }

    var mobileActions = root.querySelector('[data-lux-mobile-actions]');
    var finalSection = root.querySelector('.lux-home-v2__final');

    if (mobileActions && finalSection && 'IntersectionObserver' in window) {
      var actionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          mobileActions.classList.toggle('is-hidden', entry.isIntersecting);
        });
      }, { threshold: 0.08 });

      actionObserver.observe(finalSection);
    }

    root.querySelectorAll('.lux-home-v2__faq-list details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;

        root.querySelectorAll('.lux-home-v2__faq-list details').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });

    var items = root.querySelectorAll('[data-lux-reveal]');

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lux-home-v2]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* LUXWORLD HOMEPAGE V3.0 — lightweight cinematic interactions */
(function () {
  function initCinematic(root) {
    if (!root || root.dataset.luxCinematicReady === 'true') return;
    root.dataset.luxCinematicReady = 'true';

    var comparisons = root.querySelectorAll('[data-lux-compare]');
    comparisons.forEach(function (comparison) {
      var range = comparison.querySelector('.lux-home-v2__compare-range');
      if (!range) return;
      function updateComparison() {
        comparison.style.setProperty('--lux-compare', range.value + '%');
      }
      range.addEventListener('input', updateComparison, { passive: true });
      updateComparison();
    });

    var progressQueued = false;
    function updateProgress() {
      progressQueued = false;
      var rect = root.getBoundingClientRect();
      var distance = Math.max(1, root.offsetHeight - window.innerHeight);
      var value = Math.min(1, Math.max(0, -rect.top / distance));
      root.style.setProperty('--lux-progress', value.toFixed(4));
    }
    function queueProgress() {
      if (progressQueued) return;
      progressQueued = true;
      window.requestAnimationFrame(updateProgress);
    }
    window.addEventListener('scroll', queueProgress, { passive: true });
    window.addEventListener('resize', queueProgress, { passive: true });
    updateProgress();

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hero = root.querySelector('.lux-home-v2__hero');
    if (hero && finePointer && !reduceMotion) {
      var pointerQueued = false;
      var pointerX = 72;
      var pointerY = 28;
      function paintPointer() {
        pointerQueued = false;
        root.style.setProperty('--lux-cursor-x', pointerX.toFixed(2) + '%');
        root.style.setProperty('--lux-cursor-y', pointerY.toFixed(2) + '%');
      }
      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        pointerX = ((event.clientX - rect.left) / rect.width) * 100;
        pointerY = ((event.clientY - rect.top) / rect.height) * 100;
        if (!pointerQueued) {
          pointerQueued = true;
          window.requestAnimationFrame(paintPointer);
        }
      }, { passive: true });
    }
  }

  function initCinematicAll(scope) {
    (scope || document).querySelectorAll('[data-lux-home-v2]').forEach(initCinematic);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCinematicAll(document); });
  } else {
    initCinematicAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCinematicAll(event.target);
  });
})();

/* LUXWORLD HOMEPAGE V3.2 — category-aware guided sales journey */
(function () {
  function initSalesJourney(root) {
    if (!root || root.dataset.luxSalesReady === 'true') return;
    root.dataset.luxSalesReady = 'true';

    var finder = root.querySelector('[data-lux-project-finder]');
    if (finder) {
      var categoryStep = finder.querySelector('[data-lux-finder-step="product"]');
      var typeStep = finder.querySelector('[data-lux-finder-step="type"]');
      var serviceStep = finder.querySelector('[data-lux-finder-step="service"]');
      var result = finder.querySelector('[data-lux-finder-result]');
      var progress = finder.querySelectorAll('.lux-home-v2__finder-progress span');
      var selectedCategory = '';
      var selectedTypeGroup = '';
      var selectedProduct = '';
      var selectedProductUrl = '';
      var selectedOnlineUrl = '';
      var selectedOnlineLabel = '';

      function setStage(stage) {
        if (categoryStep) categoryStep.hidden = stage !== 1;
        if (typeStep) typeStep.hidden = stage !== 2;
        if (serviceStep) serviceStep.hidden = stage !== 3;
        if (result) result.hidden = stage !== 4;
        progress.forEach(function (item, index) {
          item.classList.toggle('is-active', index <= stage - 1);
        });
      }

      function prepareServiceStep() {
        var question = serviceStep && serviceStep.querySelector('.lux-home-v2__finder-question');
        if (question) question.textContent = 'How would you like help with ' + selectedProduct + '?';
        var back = finder.querySelector('[data-lux-finder-back-service]');
        if (back) back.textContent = selectedTypeGroup ? '← Change product type' : '← Change category';
        setStage(3);
      }

      finder.querySelectorAll('[data-lux-product]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectedCategory = button.dataset.luxProduct || 'your project';
          selectedTypeGroup = button.dataset.luxProductTypes || '';
          selectedProduct = selectedCategory;
          selectedProductUrl = button.dataset.luxProductUrl || '/';
          selectedOnlineUrl = button.dataset.luxOnlineUrl || selectedProductUrl;
          selectedOnlineLabel = button.dataset.luxOnlineLabel || ('Explore ' + selectedProduct);

          if (selectedTypeGroup && typeStep) {
            var typeQuestion = typeStep.querySelector('[data-lux-type-question]');
            if (typeQuestion) typeQuestion.textContent = 'Which ' + selectedCategory.toLowerCase() + ' type suits your space?';
            finder.querySelectorAll('[data-lux-type-parent]').forEach(function (typeButton) {
              typeButton.hidden = typeButton.dataset.luxTypeParent !== selectedTypeGroup;
            });
            setStage(2);
          } else {
            prepareServiceStep();
          }
        });
      });

      finder.querySelectorAll('[data-lux-type]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectedProduct = button.dataset.luxType || selectedCategory;
          selectedProductUrl = button.dataset.luxTypeUrl || '/';
          selectedOnlineUrl = button.dataset.luxOnlineUrl || selectedProductUrl;
          selectedOnlineLabel = button.dataset.luxOnlineLabel || ('Explore ' + selectedProduct);
          prepareServiceStep();
        });
      });

      finder.querySelectorAll('[data-lux-service]').forEach(function (button) {
        button.addEventListener('click', function () {
          var service = button.dataset.luxService || 'Your next step';
          var isOnline = service.toLowerCase().indexOf('online') > -1;
          var title = result && result.querySelector('[data-lux-finder-title]');
          var copy = result && result.querySelector('[data-lux-finder-copy]');
          var primary = result && result.querySelector('[data-lux-finder-primary]');
          var secondary = result && result.querySelector('[data-lux-finder-secondary]');
          if (title) title.textContent = selectedProduct + ': ' + service;
          if (copy) copy.textContent = 'Selected: ' + selectedProduct + '. ' + (button.dataset.luxServiceCopy || '');
          if (primary) {
            primary.href = isOnline ? selectedOnlineUrl : (button.dataset.luxServiceUrl || '/');
            primary.textContent = isOnline ? selectedOnlineLabel : (service.indexOf('Commercial') > -1 ? 'Request Project Support' : 'Book Measure & Quote');
          }
          if (secondary) {
            secondary.href = selectedProductUrl;
            secondary.textContent = 'Explore ' + selectedProduct + ' →';
          }
          setStage(4);
          root.dispatchEvent(new CustomEvent('lux:finder:complete', { detail: { category: selectedCategory, product: selectedProduct, service: service } }));
        });
      });

      var backCategory = finder.querySelector('[data-lux-finder-back-category]');
      var backService = finder.querySelector('[data-lux-finder-back-service]');
      var restart = finder.querySelector('[data-lux-finder-restart]');
      if (backCategory) backCategory.addEventListener('click', function () { setStage(1); });
      if (backService) backService.addEventListener('click', function () { setStage(selectedTypeGroup ? 2 : 1); });
      if (restart) restart.addEventListener('click', function () {
        selectedCategory = ''; selectedTypeGroup = ''; selectedProduct = ''; selectedProductUrl = ''; selectedOnlineUrl = ''; selectedOnlineLabel = ''; setStage(1);
      });
      setStage(1);
    }

    var dock = root.querySelector('[data-lux-mobile-actions]');
    var hero = root.querySelector('.lux-home-v2__hero');
    if (dock && hero) {
      var dockQueued = false;
      function updateDock() {
        dockQueued = false;
        dock.classList.toggle('is-sales-visible', hero.getBoundingClientRect().bottom < window.innerHeight * 0.36);
      }
      function queueDock() {
        if (dockQueued) return;
        dockQueued = true;
        window.requestAnimationFrame(updateDock);
      }
      window.addEventListener('scroll', queueDock, { passive: true });
      window.addEventListener('resize', queueDock, { passive: true });
      updateDock();
    }
  }

  function initSalesAll(scope) {
    (scope || document).querySelectorAll('[data-lux-home-v2]').forEach(initSalesJourney);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSalesAll(document); });
  } else {
    initSalesAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initSalesAll(event.target); });
})();
